export default __webpack_public_path__ + "static/media/PCI-DSSLogo.29461a0f.png";